import { openBlock as e, createElementBlock as o, createElementVNode as t } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, c = /* @__PURE__ */ t("path", {
  fill: "#F0F0F0",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), n = /* @__PURE__ */ t("path", {
  fill: "#D80027",
  d: "M40 20c0-7.93-4.615-14.78-11.305-18.015v36.03C35.385 34.78 40 27.93 40 20Z"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#6DA544",
  d: "M0 20c0 7.93 4.614 14.78 11.304 18.015V1.985C4.614 5.22 0 12.07 0 20Zm14.782 0a5.217 5.217 0 0 0 10.435 0v-1.74H14.782V20Z"
}, null, -1), h = /* @__PURE__ */ t("path", {
  fill: "#FF9811",
  d: "M26.956 16.522H21.74a1.74 1.74 0 0 0-3.479 0h-5.217c0 .96.837 1.739 1.797 1.739h-.058c0 .96.779 1.739 1.74 1.739 0 .96.778 1.74 1.738 1.74h3.479c.96 0 1.739-.78 1.739-1.74a1.74 1.74 0 0 0 1.739-1.74h-.058c.96 0 1.797-.778 1.797-1.738Z"
}, null, -1), i = [
  c,
  n,
  s,
  h
];
function d(_, a) {
  return e(), o("svg", l, [...i]);
}
const f = { render: d };
export {
  f as default,
  d as render
};
